import { render } from "./PaymentHistoryByWsxy.vue?vue&type=template&id=7c3fb6f2&scoped=true"
import script from "./PaymentHistoryByWsxy.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryByWsxy.vue?vue&type=script&lang=js"

import "./PaymentHistoryByWsxy.vue?vue&type=style&index=0&id=7c3fb6f2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7c3fb6f2"

export default script